import { render } from "./ServiceProcurement.vue?vue&type=template&id=30b7482e"
import script from "./ServiceProcurement.vue?vue&type=script&lang=js"
export * from "./ServiceProcurement.vue?vue&type=script&lang=js"

import "../assets/css/serviceprocurement.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__